class DragScroll extends HTMLElement {
    constructor() {
        super();
        this.isDown = false;
        this.startX;
        this.scrollLeft;
        this.slider = this.querySelector('.product--container');

        if (!this.slider) return;

        this.bindEvents();
    }

    bindEvents() {
        this.slider.addEventListener('mousedown', (e) => {
            this.isDown = true;
            this.slider.classList.add('active');
            this.startX = e.pageX - this.slider.offsetLeft;
            this.scrollLeft = this.slider.scrollLeft;
        });

        this.slider.addEventListener('mouseleave', () => {
            this.isDown = false;
            this.slider.classList.remove('active');
        });

        this.slider.addEventListener('mouseup', () => {
            this.isDown = false;
            this.slider.classList.remove('active');
        });

        this.slider.addEventListener('mousemove', (e) => {
            if (!this.isDown) return;
            e.preventDefault();
            const x = e.pageX - this.slider.offsetLeft;
            const walk = (x - this.startX) * 2; // scroll-fast
            this.slider.scrollLeft = this.scrollLeft - walk;
        });

        // Prevent default link click when dragging
        const links = this.slider.querySelectorAll('a');
        links.forEach(link => {
            link.addEventListener('click', (e) => {
                if (this.slider.classList.contains('active')) { // simplistic check, might need improvement for actual drag detection vs click
                    // Better approach: check if moved significantly
                }
            });
        });

        // Improve click vs drag detection
        let isDragging = false;
        this.slider.addEventListener('mousedown', () => isDragging = false);
        this.slider.addEventListener('mousemove', () => isDragging = true);

        links.forEach(link => {
            link.addEventListener('click', (e) => {
                if (this.isDown) { // If mouse is still down, it's weird, but if we just finished dragging
                    // Actually, the click event fires after mouseup.
                }
            });
        });
    }
}

// Re-implementing simpler logic to avoid over-engineering for now, 
// focusing on the core drag functionality requested.
// We can attach this to the container directly or use a custom element wrapper.
// Given the existing structure, let's make a function that initializes it.

function initDragScroll() {
    const sliders = document.querySelectorAll('.product--container');

    sliders.forEach(slider => {
        let isDown = false;
        let startX;
        let scrollLeft;
        let isDragging = false;

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            isDragging = false;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });

        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
            // Small timeout to reset dragging flag so click events can be blocked if needed
            setTimeout(() => isDragging = false, 0);
        });

        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            isDragging = true;
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2; // scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });

        // Prevent links from firing if we were dragging
        const links = slider.querySelectorAll('a');
        links.forEach(link => {
            link.addEventListener('click', (e) => {
                if (isDragging) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', initDragScroll);
